import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/EnableReservationsResultAdapter';
import EnableReservationsResult from '../../../models/interfaces/EnableReservationsResult';
import { enableReservations, EnableReservationsActionType, enableReservationsFailed, enableReservationsFinished } from '../../actions/place/enableReservations';
import getPublicResponse from '../getPublicResponse';

function* enableReservationsSaga({ payload }: EnableReservationsActionType) {
  const timestamp = moment();
  const { token, enable } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.enableReservations, {
    token,
    enable,
  });
  const { enableReservationsResult, placeUniqueName, error } = response;
  if (error) {
    const action = enableReservationsFailed({
      token,
      enableReservationsResult: EnableReservationsResult.failed,
      timestamp,
    });
    yield put(action);
  } else {
    const action = enableReservationsFinished({
      token,
      enableReservationsResult: fromDto(enableReservationsResult),
      placeUniqueName,
      timestamp,
    });
    yield put(action);
  }
}

export default function* watchEnableReservationsSaga() {
  yield takeEvery(enableReservations, enableReservationsSaga);
}
